export default __webpack_public_path__ + "static/media/tabler-icon-message.665cffa1.svg";